/**
 * @param {object[]} items
 * @param {object[]} clasifyBy
 * @returns {object[]}
 */
export function clasifyItems() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var clasifyBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = [];
  clasifyBy === null || clasifyBy === void 0 || clasifyBy.forEach(function (item) {
    var newItem = {
      title: item.title,
      items: []
    };
    items.forEach(function (innerItem) {
      var _item$itemsToFilter;
      if (item !== null && item !== void 0 && (_item$itemsToFilter = item.itemsToFilter) !== null && _item$itemsToFilter !== void 0 && _item$itemsToFilter.includes(innerItem === null || innerItem === void 0 ? void 0 : innerItem.Name) || item.itemsToFilter.length === 0) {
        newItem.items.push(innerItem);
      } else {
        var _innerItem$Children;
        innerItem === null || innerItem === void 0 || (_innerItem$Children = innerItem.Children) === null || _innerItem$Children === void 0 || _innerItem$Children.forEach(function (subItem) {
          var _item$itemsToFilter2;
          if (item !== null && item !== void 0 && (_item$itemsToFilter2 = item.itemsToFilter) !== null && _item$itemsToFilter2 !== void 0 && _item$itemsToFilter2.includes(subItem.Name)) {
            newItem.items.push(subItem);
          }
        });
      }
    });
    newItem.items.length > 0 && result.push(newItem);
  });
  return result;
}

// O(n²)